module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-700-bold-dc2d228c135d162e58a98203309a05dc.woff2";